import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_MANUAL_INVOICE_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetInvoiceManualPayload, GetInvoiceManualResult, ManualBill } from '../types/getManualBill.types';

export const INVOICE_MANUAL = 'InvoiceManual';

export const getInvoiceManual = (builder: BuilderType) =>
  builder.query<ManualBill, GetInvoiceManualPayload>({
    providesTags: [INVOICE_MANUAL],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_MANUAL_INVOICE_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetInvoiceManualResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return response.Result.ManualBill;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
